module.exports = __webpack_public_path__ + "img/consultoria_4-3_2048.b6c23105.webp";